// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"532":"9937aaf0467b7f3a2184","678":"7aab825dfafc1569624e","763":"c0e44eba13db853c6414"}[chunkId] + ".js";
};